import React from 'react';

const EducationLevelListing = ({ data, isLoading, searchQuery }) => {
    return (
        <div
            className="table-card"
            style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                paddingBottom: '10px'
            }}
        >
            <table className="custom-table" style={{ minWidth: '500px' }}>
                <thead>
                    <tr>
                        <th width="10%" style={{ textAlign: 'center' }}>STT</th>
                        <th width="60%">TRÌNH ĐỘ ĐÀO TẠO</th>
                        <th width="30%" style={{ textAlign: 'center' }}>MÃ VIẾT TẮT</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan="3" style={{ textAlign: 'center', padding: '60px', color: '#003399' }}>
                                <i className="fa-solid fa-circle-notch fa-spin" style={{ fontSize: '35px', marginBottom: '15px', display: 'block' }}></i>
                                Đang tải dữ liệu từ máy chủ
                            </td>
                        </tr>
                    ) :
                        !Array.isArray(data) || data.length === 0 ? (
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'center', padding: '50px', color: '#888' }}>
                                    <i className="fa-solid fa-magnifying-glass-minus" style={{ fontSize: '30px', display: 'block', marginBottom: '15px', color: '#ccc' }}></i>
                                    {(!Array.isArray(data)) ? "Lỗi dữ liệu hoặc chưa được cấp quyền" : "Không tìm thấy trình độ nào trùng khớp"}
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index) => (
                                <tr key={item.Id}>
                                    <td style={{ textAlign: 'center' }}>{index + 1}</td>
                                    <td style={{ fontWeight: '600', color: '#333' }}>{item.Name}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <span style={{
                                            background: '#f3e5f5',
                                            color: '#7b1fa2',
                                            padding: '5px 15px',
                                            borderRadius: '6px',
                                            fontSize: '12px',
                                            fontWeight: 'bold',
                                            border: '1px solid #e1bee7'
                                        }}>
                                            {item.Code}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                </tbody>
            </table>
        </div>
    );
};

export default EducationLevelListing;